import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { testimonials } from '../data/offer';
export function TestimonialsSection() {
  return <section className="bg-brand-alt px-4 py-20 md:py-28" data-id="element-156" data-mp="1n00ojw8ieprz">
      <Reveal className="mx-auto max-w-6xl" data-id="element-157" data-mp="1mziun69bknn8">
        <div className="mb-12 text-center" data-id="element-158" data-mp="1r1m5bso5zo7g">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-green" data-id="element-159" data-mp="1r0b4a0m3suk1">DOCENTES QUE YA LO USAN</p>
          <h2 className="text-3xl font-black text-brand-deep md:text-4xl" data-id="element-160" data-mp="1d0jjnh130fx2">Lo que dicen las profes de Biología</h2>
          <p className="mt-4 font-semibold text-brand-gray" data-id="element-161" data-mp="1hyuunv344wgv">
            Clases claras, laboratorios listos y muchas horas ahorradas
          </p>
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-162" data-mp="183t3yut6vmc6">
          {testimonials.map(({
          quote,
          name,
          role
        }) => <article key={name} className="flex min-h-[220px] flex-col rounded-2xl border border-brand-dark bg-brand-main p-7" data-id="element-163" data-mp="2yfz14a2wbtxy">
              <div className="flex gap-1" data-id="element-164" data-mp="2v0j5toot62z9">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-4 w-4 fill-brand-yellow text-brand-yellow" aria-hidden="true" data-id="element-165" data-mp="2q1g9csmw952w" />)}
              </div>
              <p className="mt-5 font-serif text-lg italic leading-relaxed" data-id="element-166" data-mp="34t8bg2xogmmo">{quote}</p>
              <div className="mt-auto pt-6" data-id="element-167" data-mp="2zudvr9v0be6s">
                <p className="text-sm font-bold text-brand-deep" data-id="element-168" data-mp="2c26vw0q2op2m">{name}</p>
                <p className="text-xs text-brand-gray" data-id="element-169" data-mp="273n7lto0b173">{role}</p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}